module.exports = __webpack_public_path__ + "img/logoBMWI.8a0560f5.jpg";